import { createFileRoute } from "@tanstack/react-router";

import { LabelPrintView } from "@/features/receptura/label-print";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/receptura/protokoly_/$id_/etykieta")({
	component: LabelPrintRoute,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.receptura.protokoly",
			location.pathname,
		);
	},
});

function LabelPrintRoute() {
	const { id } = Route.useParams();
	return <LabelPrintView protocolId={Number(id)} />;
}
